export default {
  // Hardcoded ID on the button, to assist targeting tools
  // e.g. testing, analytics etc.
  TARGETING_ID: "chatbot-launcher-btn",
  // URL part defaults
  DEFAULT_PROTOCOL: "https:",
  DEFAULT_ORIGIN: "www.nib.com.au",
  OS_HOSTNAMES: ["my.nib.com.au", "my.nib-cf-test.com"]
};